import { render } from "./product-stat.vue?vue&type=template&id=fa77d8da"
import script from "./product-stat.vue?vue&type=script&lang=js"
export * from "./product-stat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__